import classNames from 'classnames';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { FormattedMessage } from 'react-intl';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import capitalize from '../../lib/capitalize';
import TextInput from '../../TextInput';

const autocompletableFields = ['line1', 'district', 'city', 'state'];

class BrazilianAddressInput extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    className: PropTypes.string,
    tabIndex: PropTypes.number,
  };

  static defaultProps = {
    className: undefined,
    tabIndex: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { postalCode } = nextProps.input.value;
    if (postalCode && postalCode !== this.props.input.value.postalCode && this.hasFieldsToFill()) {
      const cleanPostalCode = postalCode.replace(/\D/g, '');
      if (cleanPostalCode.length >= 8) {
        this.setState({ loading: true });
        this.queryData(cleanPostalCode);
      }
    }
  }

  queryData = async postalCode => {
    try {
      const {
        data: { addressByPostalCode: address },
      } = await this.props.client.query({
        query: addressByPostalCode,
        variables: { postalCode },
      });
      this.updateAddressData(address);
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  updateAddressData = address => {
    const currentValue = this.props.input.value || {};
    this.props.input.onChange({
      ...currentValue,
      line1: currentValue.line1 || address.line1 || '',
      district: currentValue.district || address.district || '',
      city: currentValue.city || address.city || '',
      state: currentValue.state || address.state || '',
    });

    this.setState({ loading: false });
  };

  hasFieldsToFill = () => {
    const {
      input: { value },
    } = this.props;
    return !value || autocompletableFields.some(field => !value[field]);
  };

  onChange = fieldType => event => {
    const { value, onChange } = this.props.input;
    onChange({ ...value, [fieldType]: event.target.value });
  };

  getPropsForType(type, className) {
    const {
      input: { value },
      classes,
      meta,
      tabIndex,
    } = this.props;
    const { loading } = this.state;

    return {
      input: {
        value: value[type] || '',
        onChange: this.onChange(type),
      },
      label: <FormattedMessage id={`address${capitalize(type)}`} />,
      className: classNames(classes.input, className),
      required: type !== 'line2',
      meta: {
        ...meta,
        error: meta && meta.error && meta.error[type],
      },
      disabled: loading && !value[type] && autocompletableFields.includes(type),
      name: type,
      tabIndex,
    };
  }

  render() {
    const { classes, className } = this.props;
    const { loading } = this.state;

    return (
      <div className={className}>
        <div className={classes.row}>
          <TextInput
            {...this.getPropsForType('postalCode', classes.postalCode)}
            loading={loading}
            placeholder="00000-000"
            mask="99999-999"
            type="tel"
          />
        </div>
        <div className={classes.row}>
          <TextInput {...this.getPropsForType('line1')} />
        </div>
        <div className={classes.row}>
          <div className={classes.rowFragment}>
            <TextInput {...this.getPropsForType('number', classes.number)} />
            <TextInput {...this.getPropsForType('line2', classes.line2)} />
          </div>
          <TextInput {...this.getPropsForType('district', classes.district)} />
        </div>
        <div className={classes.row}>
          <TextInput {...this.getPropsForType('city', classes.city)} />
          <TextInput {...this.getPropsForType('state', classes.state)} />
        </div>
      </div>
    );
  }
}

const stylesheet = theme => ({
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    '&:not(:first-child)': {
      marginTop: theme.spacing.unit,
    },
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
    },
  },
  input: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      '&:not(:first-child)': {
        marginTop: theme.spacing.unit,
      },
    },
    [theme.breakpoints.up('sm')]: {
      '&:not(:first-child)': {
        marginLeft: theme.spacing.unit,
      },
    },
  },
  postalCode: {
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
  },
  number: {
    [theme.breakpoints.up('sm')]: {
      flex: 3,
    },
  },
  line2: {
    [theme.breakpoints.up('sm')]: {
      flex: 4,
    },
  },
  rowFragment: {
    [theme.breakpoints.up('sm')]: {
      flex: 7,
      display: 'flex',
    },
  },
  district: {
    [theme.breakpoints.up('sm')]: {
      flex: 5,
    },
  },
  city: {
    [theme.breakpoints.up('sm')]: {
      flex: 7,
    },
  },
  state: {
    [theme.breakpoints.up('sm')]: {
      flex: 5,
    },
  },
});

const addressByPostalCode = gql`
  query addressByPostalCode($postalCode: String!) {
    addressByPostalCode(postalCode: $postalCode) {
      line1
      district
      city
      state
    }
  }
`;

export default compose(
  withApollo,
  injectSheet(stylesheet),
)(BrazilianAddressInput);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/AddressInput/BrazilianAddressInput.js